const HandleResponse = (thunkAPI, response) => {
  if (response && response.status >= 200 && response.status < 300) {
    return thunkAPI.fulfillWithValue(response.data);
  }

  return thunkAPI.rejectWithValue();
};

export default HandleResponse;
